module.exports = __webpack_public_path__ + "media/images/icon-folder-1f44e178.jpg";